import { render, staticRenderFns } from "./TabOxygenConcentratorWorkingPrinciple.vue?vue&type=template&id=5e1a0d73&scoped=true"
import script from "./TabOxygenConcentratorWorkingPrinciple.vue?vue&type=script&lang=js"
export * from "./TabOxygenConcentratorWorkingPrinciple.vue?vue&type=script&lang=js"
import style0 from "./TabOxygenConcentratorWorkingPrinciple.vue?vue&type=style&index=0&id=5e1a0d73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1a0d73",
  null
  
)

export default component.exports